import "core-js/modules/es.function.name.js";
/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { _ToolTipWrapper } from "./style";
var BasicToolTip = function BasicToolTip(props) {
  return /*#__PURE__*/React.createElement(_ToolTipWrapper, {
    "data-tip": props.text
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: props.name
  }));
};
export default BasicToolTip;